// Setter §09.4: structured objections of an opportunity. Schemas in api-objections.ts.
import { LeadObjectionsSchema } from './api-objections.js';
import { IdParam, route, W } from './route-def.js';

export const objectionRoutes = {
  listLeadObjections: route({
    method: 'GET', path: '/workspaces/:workspaceId/leads/:interestId/objections', summary: 'Objeciones registradas de una oportunidad', tag: 'leads',
    minRole: 'advisor', module: null, params: W({ interestId: IdParam }), response: LeadObjectionsSchema,
  }),
} as const;
